import { loadBrandOnce } from "../../root/rootLoader.ts";

async function importComponents() {
  const brand = await loadBrandOnce();

  if (brand.Explore.fractionIframeEnabled) {
    return import("../explore-iframe/lazyRoute.tsx");
  } else {
    return import("../explore-integrated/lazyRoute.tsx");
  }
}

function getLayout() {
  return importComponents().then((data) => data.layout);
}

function getMain() {
  return importComponents().then((data) => data.main);
}

function getSubscription() {
  return importComponents().then((data) => data.subscription);
}

function getBorrowedItems() {
  return importComponents().then((data) => data.borrowedItems);
}

export const exploreRoutes = {
  path: "/explore",
  lazy() {
    return getLayout();
  },
  children: [
    {
      exact: true,
      path: "/explore",
      lazy() {
        return getMain();
      },
    },
    {
      path: "/explore/:subscriptionVbid",
      lazy() {
        return getSubscription();
      },
    },
    {
      path: "/explore/borrowed-items",
      async lazy() {
        return getBorrowedItems();
      },
    },
  ],
};
